import { Roles } from '../const/permissions'

export const checkRole = (roles: Roles[], requiredRoles: Roles[]) => {
  return roles.some((role) => requiredRoles.includes(role))
}
